'use client'

import { useEffect, useState } from 'react'

export function DynamicFavicon() {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  useEffect(() => {
    if (!mounted) return

    // 检查是否存在自定义favicon
    const checkAndUpdateFavicon = async () => {
      try {
        // 尝试获取自定义favicon
        const response = await fetch('/favicon.ico', { method: 'HEAD' })
        
        if (response.ok) {
          // 如果存在自定义favicon，更新所有相关图标
          updateFaviconLinks()
        } else {
          // 如果不存在，使用默认配置（如果需要的话）
          console.log('Using default favicon configuration')
        }
      } catch {
        console.log('Using default favicon configuration')
      }
    }

    checkAndUpdateFavicon()
  }, [mounted])

  const updateFaviconLinks = () => {
    // 移除现有的favicon和icon相关link
    const existingLinks = document.querySelectorAll('link[rel*="icon"], link[rel*="apple-touch-icon"]')
    existingLinks.forEach(link => link.remove())

    // 定义favicon配置
    const faviconConfigs = [
      { rel: 'icon', type: 'image/x-icon', href: '/favicon.ico' },
      { rel: 'icon', type: 'image/png', sizes: '16x16', href: '/favicon-16x16.png' },
      { rel: 'icon', type: 'image/png', sizes: '32x32', href: '/favicon-32x32.png' },
      { rel: 'icon', type: 'image/png', sizes: '96x96', href: '/favicon-96x96.png' },
      { rel: 'icon', type: 'image/png', sizes: '192x192', href: '/favicon-192x192.png' },
      { rel: 'apple-touch-icon', type: 'image/png', sizes: '180x180', href: '/apple-touch-icon.png' }
    ]

    // 添加新的favicon links
    faviconConfigs.forEach(config => {
      const link = document.createElement('link')
      link.rel = config.rel
      link.type = config.type
      link.href = config.href
      
      if (config.sizes) {
        link.setAttribute('sizes', config.sizes)
      }
      
      document.head.appendChild(link)
    })

    console.log('✅ Dynamic favicon links updated')
  }

  return null
} 